import { IShipmentStopTypes } from 'types/graphqlTypes'
import { IAwardedLaneFragment } from 'apps/marketplace/pages/awarded-lanes/graphql/AwardedLaneFragment'
import { DISPLAY } from 'constants/display'
import { getAwardedLaneLoadingMethod } from './getAwardedLaneLoadingMethod'
import { getAwardedLaneWeight } from './getAwardedLaneWeight'

export const getLaneDetailsClipboardContent = (awardedLane: IAwardedLaneFragment): string => {
  const {
    equipment,
    isDeliveryDropTrailer,
    isPickupDropTrailer,
    listingDetails,
    shipperRateShipperFacilities,
  } = awardedLane
  const { name: equipmentName } = equipment ?? {}
  const { commodity, maxWeight, minWeight, note, offerLeadTime } = listingDetails ?? {}
  const loadingMethod = getAwardedLaneLoadingMethod(isPickupDropTrailer, isDeliveryDropTrailer)
  const weight = getAwardedLaneWeight({
    minWeight,
    maxWeight,
  })
  const formattedOfferLeadTime = offerLeadTime ? `Usually ${offerLeadTime} Days` : null

  const pickupSrsf = shipperRateShipperFacilities.find(
    ({ stopType }) => stopType === IShipmentStopTypes.pickup
  )
  const deliverySrsf = shipperRateShipperFacilities.find(
    ({ stopType }) => stopType === IShipmentStopTypes.delivery
  )

  const pickupFacilityName = pickupSrsf?.shipperFacility.facility.name
  const deliveryFacilityName = deliverySrsf?.shipperFacility.facility.name

  return `
    Equipment: ${equipmentName ?? DISPLAY.empty}
    Loading Method: ${loadingMethod}
    Commodity: ${commodity ?? DISPLAY.empty}
    Weight: ${weight ?? DISPLAY.empty}
    Offer Lead Time: ${formattedOfferLeadTime ?? DISPLAY.empty}
    Pickup Facility: ${pickupFacilityName ?? DISPLAY.empty}
    Dropoff Facility: ${deliveryFacilityName ?? DISPLAY.empty}
    Note: ${note}
    `
}
